import type React from 'react'

import { clsJoin } from '@/utils'
import { ProjectNameInput } from './components/ProjectNameInput'
import css from './styles.module.css'
import { useProjectName } from './useProjectName'

export const ProjectName: React.FC = () => {
  const {
    name,
    access,
    showRenameProject,
    collaborators,
    handleNameClick,
    handleHideInput,
  } = useProjectName()

  const cn = clsJoin(
    css.project_name,
    !access && css.disabled,
    collaborators.length > 0 && css.with_collaborators
  )

  if (showRenameProject) {
    return (
      <ProjectNameInput
        name={name}
        showInput={showRenameProject}
        collaboratorsLength={collaborators.length}
        onHideInput={handleHideInput}
      />
    )
  }

  return (
    <div className={cn} onClick={handleNameClick}>
      {name}
    </div>
  )
}
